angular.module('TetherApp').directive('tetherSelect', function () {
    return {
        restrict: 'E',
        templateUrl: '/html/form/tetherSelect.html'
    }
});
